import { defineStore } from 'pinia';

export const useOfflineModeStore = defineStore('offlineModeStore', {
	state: () => ({
		is_online: navigator.onLine ?? true,
		is_syncing_offline_edits: false,

		is_offline_mode_syncing_modal_open: false,
		offline_mode_sync_progress: 0,
		offline_mode_sync_edits: [
			// {
			// 	edit_key: '2232',
			// 	entity: 'show',
			// 	entity_id: '123',
			// 	action: 'create',
			// 	entity_data: { custom_name: 'Test Offline 3' },
			// 	edit_created_on: new Date().getTime(),
			// 	finished_syncing: true,
			// },
			// {
			// 	edit_key: '2233',
			// 	entity: 'show',
			// 	entity_id: '123',
			// 	action: 'update',
			// 	entity_data: { custom_name: 'Test Offline 3' },
			// 	edit_created_on: new Date().getTime(),
			// 	is_syncing: true,
			// },
		],
	}),
	actions: {
		// setOutOfDate(status) {
		// 	this.is_out_of_date = !!status;
		// },
	},
});
